import loginSaga from 'src/app/redux/sagas/login/loginSaga';
import loginEmailSaga from 'src/app/redux/sagas/login/loginEmailSaga';
import loginPasswordSaga from 'src/app/redux/sagas/login/loginPasswordSaga';


export default [
  ...loginEmailSaga,
  ...loginPasswordSaga,
  ...loginSaga
];
